var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUnderlinedU48Line = function SvgIconUnderlinedU48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.4H11v3.4h26v-3.4ZM24 30.9c-5.4 0-9.8-4.4-9.8-9.8v-11h3.6v11c0 3.42 2.78 6.2 6.2 6.2 3.42 0 6.2-2.78 6.2-6.2v-11h3.6v11c0 5.4-4.4 9.8-9.8 9.8Z",
    fill: "current"
  })));
};
export default SvgIconUnderlinedU48Line;